import React from "react";
import { Radio } from "antd";
import { AppstoreOutlined, UnorderedListOutlined } from "@ant-design/icons";

const ViewToggle = ({ viewMode, onViewModeChange }) => {
  return (
    <Radio.Group
      className="creative-library__view-toggle"
      value={viewMode}
      onChange={(e) => onViewModeChange(e.target.value)}
      buttonStyle="solid"
      size="small"
    >
      <Radio.Button value="list">
        <UnorderedListOutlined />
      </Radio.Button>
      <Radio.Button value="grid">
        <AppstoreOutlined />
      </Radio.Button>
    </Radio.Group>
  );
};

export default ViewToggle;
